/**
 * How each notification source looks in the bell: one glyph from ui/icon.tsx and one i18n label.
 * Kept out of the bell component so the popup and the Site Content log share the same mapping.
 */
import type { NotificationKind } from '@system/shared'

export const KIND_ICON: Record<NotificationKind, string> = {
  issue: 'clipboard',
  doc: 'doc',
  leave: 'calendar',
  event: 'flag',
  product: 'rocket',
  handbook: 'doc',
  announce: 'users',
  system: 'gear',
  okr: 'flag',
  game: 'star',
}

/** The chip colour per source, so a glance at the bell tells apart an event from a leave from a release. */
export const KIND_TONE: Record<NotificationKind, string> = {
  issue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200',
  doc: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-200',
  leave: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200',
  event: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-200',
  product: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-200',
  handbook: 'bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-200',
  announce: 'bg-primary-soft text-primary',
  system: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
  okr: 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-200',
  game: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200',
}

export function kindLabelKey(kind: NotificationKind): string {
  return `notify.kind.${kind}`
}
